import { getCached } from "./fileCache";

/**
 * Downloads use IndexedDB cache (set on upload/preview) or the same-origin storage proxy.
 */
export function downloadBlob(blob, filename) {
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
}

function mimeFor(file) {
  return file.mime || "application/octet-stream";
}

export async function downloadFile(file, getUrl) {
  if (file.content != null) {
    downloadBlob(new Blob([file.content], { type: mimeFor(file) }), file.name);
    return "cached-text";
  }

  const cached = await getCached(file.id);
  if (cached) {
    downloadBlob(cached instanceof Blob ? cached : new Blob([cached], { type: mimeFor(file) }), file.name);
    return "cached-blob";
  }

  // Stream straight from the same-origin proxy — the browser pipes bytes to disk
  // without buffering the whole response, so the save dialog appears instantly
  // even for multi-GB files.
  const url = typeof getUrl === "function" ? await getUrl() : getUrl;
  if (!url) throw new Error("No URL available for download");

  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  return "streamed";
}
